import * as $ from 'jquery';
import {Global} from '../init-global';

require('jquery-debounced-and-throttled-resize/jquery.debouncedresize.js');
const simpleParallax = require('simple-parallax-js');


export class OverlappingPhotoTiles {

    protected $root: JQuery;
    protected isMobile: boolean;
    protected breakpoint: number = 980;

    protected photoOne: JQuery;
    protected photoTwo: JQuery;
    protected photoThree: JQuery;
    protected photoFour: JQuery;
    protected photoFive: JQuery;
    protected photoSix: JQuery;


    constructor(elem: HTMLElement)
    {
        this.$root = $(elem);
        this.bindUI();
    }

    private bindUI = () => {
        this.photoOne   = $('.c-overlapping-photo-tiles__item--1 img', this.$root);
        this.photoTwo   = $('.c-overlapping-photo-tiles__item--2 img', this.$root);
        this.photoThree = $('.c-overlapping-photo-tiles__item--3 img', this.$root);
        this.photoFour  = $('.c-overlapping-photo-tiles__item--4 img', this.$root);
        this.photoFive  = $('.c-overlapping-photo-tiles__item--5 img', this.$root);
        this.photoSix   = $('.c-overlapping-photo-tiles__item--6 img', this.$root);

        this.refreshViewport();

        // Watch the viewport for size changes
        $(window).on('debouncedresize', () => this.refreshViewport());
    }

    private initDesktop = () => {
        /*new simpleParallax(this.photoOne.get(0), {
            delay: .6,
            transition: 'cubic-bezier(0,0,0,1)'
        });*/
        //let image = document.getElementsByClassName('c-overlapping-photo-tiles__item');

        new simpleParallax(this.photoOne.get(0), {
            scale: 1.6,
            orientation: 'down',
            transition: 'ease-out',
            overflow: true
        });

        new simpleParallax(this.photoTwo.get(0), {
            scale: 2.2,
            orientation: 'down',
            transition: 'ease-out',
            overflow: true
        });

        new simpleParallax(this.photoThree.get(0), {
            scale: 1.5,
            orientation: 'down',
            transition: 'ease-out',
            overflow: true
        });

        new simpleParallax(this.photoFour.get(0), {
            scale: 0.25,
            orientation: 'down',
            transition: 'ease-out',
            overflow: true
        });

        new simpleParallax(this.photoFive.get(0), {
            scale: 2.5,
            orientation: 'down',
            transition: 'ease-out',
            overflow: true
        });

        new simpleParallax(this.photoSix.get(0), {
            scale: 2.8,
            orientation: 'down',
            transition: 'ease-out',
            overflow: true
        });
    }

    private initMobile = () => {
       	
    }

    private refreshViewport = () => {
        let vp = Global.getViewport();
        let dspForMobile:boolean = (vp.width < this.breakpoint) ? true: false;

        if (dspForMobile != this.isMobile) {
            this.isMobile = dspForMobile;
            (this.isMobile) ? this.initMobile(): this.initDesktop();
        }
    }
}